import { useCallback, useEffect, useState } from 'react'
import { useRouter } from '~/hooks/useRouter'
import { FormattedMessage } from 'react-intl'

import { CatalogSection } from '~/components/CatalogSection/CatalogSection'
import type { CatalogProductType } from '~/presets/catalogPresets'

import styles from './CatalogPage.module.css'

const VALID_TYPES: CatalogProductType[] = [
  'wardrobe',
  'stand',
  'tv-stand',
  'bedside',
  'rack',
  'table',
  'work-table',
]

const DEFAULT_TYPE: CatalogProductType = 'wardrobe'

function parseTypeFromQuery(raw: unknown): CatalogProductType {
  if (
    typeof raw === 'string' &&
    VALID_TYPES.includes(raw as CatalogProductType)
  ) {
    return raw as CatalogProductType
  }
  return DEFAULT_TYPE
}

export const CatalogPage: React.FC = () => {
  const router = useRouter()

  const [selectedType, setSelectedType] =
    useState<CatalogProductType>(DEFAULT_TYPE)

  useEffect(() => {
    if (!router.isReady) return
    const parsed = parseTypeFromQuery(router.query.type)
    setSelectedType((prev) => (prev !== parsed ? parsed : prev))
  }, [router.isReady, router.query.type])

  const handleTypeChange = useCallback(
    (type: CatalogProductType) => {
      setSelectedType(type)

       
      const { type: _omit, ...restQuery } = router.query
      const query = type === DEFAULT_TYPE ? restQuery : { ...restQuery, type }
      router.replace({ pathname: router.pathname, query }, undefined, {
        shallow: true,
      })
    },
    [router]
  )

  return (
    <div className={styles.container}>
      {/*
        Catalog's single h1: the visible page heading, in the content flow.
        /catalog has no <SeoContentSection> block (main.tsx renders it only for
        configurator.* routes) — the visual grid reads better without a text
        block under it. Note: this route is lazy-loaded, so the h1 is
        client-rendered, not in the prerendered HTML.
      */}
      <h1 id="catalog" className={styles.heading}>
        <FormattedMessage
          id="catalog.page.heading"
          defaultMessage="Catalogul nostru"
        />
      </h1>

      <CatalogSection
        selectedType={selectedType}
        onTypeChange={handleTypeChange}
      />
    </div>
  )
}
